import * as React from 'react';

import * as styles from './PageHeader.css';

interface IPageHeaderProps {
  title: string;
  location: React.ReactNode;
  searchSuggest: React.ReactNode;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({ title, location, searchSuggest }) => {
  return (
    <div className={styles['container']} data-name="PageHeader">
      <h1 className={styles['title']}>{title}</h1>
      <div className={styles['location']}>{location}</div>
      <div className={styles['search-suggest']}>{searchSuggest}</div>
    </div>
  );
};
